import {
    createStore, compose, applyMiddleware, Store, AnyAction,
} from "redux";
import createSagaMiddleware from "redux-saga";
import { routerMiddleware } from "connected-react-router";
import { History } from "history";
import { IStoreState } from "./store";
import { createRootReducer } from "./reducers";
import { isBrowser } from "@montana/helpers/browser.helper";
import { staticSettings } from "@montana/helpers/static-settings.helper";

export let store: Store<IStoreState>;

export const sagaMiddleware = createSagaMiddleware();

export const configureStore = (
    history: History,
    initialState?: IStoreState
): Store<IStoreState> => {
    const middlewares = [sagaMiddleware, routerMiddleware(history)];

    // eslint-disable-next-line no-underscore-dangle
    const reduxDevTools = isBrowser && staticSettings?.isDebugging && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ !== undefined;

    // eslint-disable-next-line no-underscore-dangle
    const composeEnhancers = reduxDevTools ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : compose;

    store = createStore(
        createRootReducer(history),
        // @ts-ignore
        initialState,
        // @ts-ignore
        composeEnhancers(
            applyMiddleware(...middlewares)
        ),
    );

    return store;
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const mergeObjectsRecursively = <TMainObject extends {[key: string]: any}>(objA: TMainObject, objB?: object): TMainObject => {
    if (!objB) {
        return objA;
    }

    try {
        const keysB = Object.keys(objB);

        if (typeof objA !== "object") {
            return objA;
        }

        const keysA = Object.keys(objA);
        const matchedKeys = keysA.filter((k): boolean => keysB.indexOf(k) !== -1);

        if (matchedKeys.length === 0) {
            return keysA.reduce((obj, k) => ({ ...obj, [k]: mergeObjectsRecursively(objA[k], objB) }), {} as TMainObject);
        }

        return { ...objA, ...objB };
    } catch (e) {
        return {} as TMainObject;
    }
};



export const configureTestStore = (history: History, subState?: Partial<IStoreState>): Store<IStoreState> => {
    const initialState = createRootReducer(history)({} as IStoreState, {} as AnyAction);
    const state = mergeObjectsRecursively(initialState, subState);

    return configureStore(history, state);
};

